module.exports = __webpack_public_path__ + "img/dku.03202.789a45a5.png";